import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  Route,
} from "react-router-dom";
import Login from "./components/pages/auth/Login";
import Register from "./components/pages/auth/Register";
import Home from "./components/pages/Home";
import Dashboard from "./components/pages/Dashboard";
import NotFound from "./components/pages/NotFound";
import ProfilePage from "./components/pages/auth/Profile";
import KnowledgeBase from "./components/pages/Knowledge/KnowledgeBase";
import KnowledgeDetail from "./components/pages/Knowledge/KnowledgeDetail";
import QualityCertifica from "./components/pages/Quality/QualityCertificates";
import StandardDocument from "./components/pages/Quality/StandardDocument";
import AccountingDocument from "./components/pages/Accounting/AccountingDocument";
import SalesDocument from "./components/pages/Sales/SalesDocument";
import RoleManagemenetPage from "./components/pages/RoleManagement/RolePage";
import PersonelYonetimiPage from "./components/pages/RoleManagement/PersonelYonetimiPage.jsx";
import ReminderDocument from "./components/pages/ReminderDocuments/Documents";
import PlanningDocument from "./components/pages/planning/PlanningDocuments";
import HumanResourcesDocument from "./components/pages/human-resources/HumanResourcesDocuments";
import ForeignTradeDocument from "./components/pages/foreign-trade/ForeignTradeDocuments";
import AdministrativeDocument from "./components/pages/administrative/AdministrativeDocuments";
import BoruProfilUretimGunlukAnaliz from "./components/pages/uretim/boruProfilUretimGunlukAnaliz";
import OperatorScreen from "./components/pages/uretim/OperatorScreen";
import PaymentDueList from "./components/pages/foreign-trade/VesselTable";
import { AuthProvider } from "./components/context/AuthContext";

import ProtectedRoute from "./routes/ProtectedRoute";
import ProtectedRouteWithPerm from "./routes/ProtectedRouteWithPerm";
import Modal from "react-modal";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import UretimDocument from "./components/pages/uretim/uretimDocument";
import BakimDocument from "./components/pages/Bakim/BakimDocument";
import SatinAlmaDocument from "./components/pages/SatinAlmaDocument/SatinAlmaDocument";
import SharedQualityDocument from "./components/pages/Quality/sharedDocumentQuality";
import SharedDocumentAll from "./components/pages/General/sharedDocumentAll";
import SharedAccountingDocument from "./components/pages/Accounting/sharedDocumentAccounting";
import SharedHumanResourcesDocument from "./components/pages/human-resources/sharedIkDocument";
import SharedForeignTradeDocument from "./components/pages/foreign-trade/SharedForeignTrade";
import SharedSatinAlmaDocument from "./components/pages/SatinAlmaDocument/sharedSatinAlmaDocument";
import SharedUretimDocument from "./components/pages/uretim/sharedDocumentUretim";
import IsgDocument from "./components/pages/ISG/IsgDocument";
import SharedISGDocument from "./components/pages/ISG/sharedDocumentIsg";
import IsgPersonelCertifica from "./components/pages/ISG/personelCertifica";
import StokAnaliz from "./components/pages/planning/stokAnaliz";
import IKPersonelList from "./components/pages/human-resources/personelList";
import IadeRapor from "./components/pages/Quality/IadeRapor";
import QualityFileManagerPage from "./components/pages/Quality/Qmad/QualityFileManagerPage.js";
import QualityDocumentDetailPage from "./components/pages/Quality/Qmad/QualityDocumentDetailPage.js";

import EUkota from "./components/pages/foreign-trade/EUkota";
import UKkota from "./components/pages/foreign-trade/UKkota.js";
import MakinaUretimAnaliz from "./components/pages/uretim/makineUretim";
import MakinaUretimAnalizDemo from "./components/pages/uretim/MakinaUretimDemo";
import MakinaOrtalamaKalinlikAnaliz from "./components/pages/uretim/MakinaOrtalamaKalinlikAnaliz";
import MakinaExcelDebugPage from "./components/pages/uretim/MakinaExcelDebugPage";
import MakinaExcelImportKontrolPage from "./components/pages/uretim/MakinaExcelImportKontrolPage";
import MakineSureAnaliz from "./components/pages/uretim/sureAnaliz";
import AylikBoruProfilAnaliz from "./components/pages/uretim/monthlyBoruProfilAnaliz";
import SevkRapor from "./components/pages/Quality/SevkRapor";
import BoruProfilAnlik from "./components/pages/uretim/boruProfilUretimAnlik";
import OperatorPageV3 from "./components/pages/uretim/boruProfilUretimDetay";
import MailSettingsPage from "./components/pages/mailSettings/MailSettingsPage";
import OperatorPerformansPage from "./components/pages/uretim/operatorPerformans";
import SevkiyatListe from "./components/pages/sevkiyat/SevkiyatList";
import ToplamGunlukSureAnaliz from "./components/pages/uretim/boruGunlukToplam";
import BoruSureAnaliz from "./components/pages/uretim/boruSureAnaliz";
import HatHizStandartPage from "./components/pages/planning/HatHizStandartPage";
import CustomerListPage from "./components/pages/foreign-trade/CustomerList";
import CustomerDetailPage from "./components/pages/foreign-trade/CustomerDetailView";
import UretimPlanlamaPage from "./components/pages/planning/UretimPlanlamaPage";
import SevkiyatLiveCameraPage from "./components/pages/planning/SevkiyatLiveCameraPage";
import ProductionSalesSummaryPage from "./components/pages/planning/ProductionSalesSummaryPage";
import ExportOrderCreatePage from "./components/pages/foreign-trade/OrderPage";
import CustomerAnalysisPage from "./components/pages/foreign-trade/CustomerAnalysisPage";
import CleaningPlanManagement from "./components/pages/Bakim/MachineCleaning";
import EquipmentPlanManagement from "./components/pages/Bakim/EquipmentReminder";
import HygienePlanPage from "./components/pages/Bakim/HygienePlanPage";
import DiningHallCleaningPlanManagement from "./components/pages/Bakim/KitchenPlanPage";
import HizPerformansRaporuPage from "./components/pages/uretim/HatHizFarkAnaliz";
import ShipmentDashboard from "./components/pages/planning/ShipmentDashboard.js";
import KonteynerPlanlama from "./components/pages/planning/KonteynerPlanlama.js";
import KonteynerYuklemePage from "./components/pages/planning/konteyner/KonteynerYuklemePage.jsx";
import KonteynerKuralPage from "./components/pages/planning/konteyner/KonteynerKuralPage.jsx";
import KonteynerSunumPage from "./components/pages/planning/konteyner/KonteynerSunumPage.jsx";
import TicketPage from "./components/pages/TicketPage.js";
import TicketAnalizPage from "./components/pages/TicketAnalizPage.js";
import RuloStokSatisGiris from "./components/pages/Satis/SellerPage.js";
import DofiWizard from "./components/pages/Dof/DofCreate.js";
import DofList from "./components/pages/Dof/DofList.js";
import DofEdit from "./components/pages/Dof/DofEdit.js";
import DofDetail from "./components/pages/Dof/DofDetail.js";
import DirectorNavlunAnalysisPage from "./components/pages/Director/DirectorNavlunAnalysisPage.js";
import DirectorNavlunRequestDetailPage from "./components/pages/Director/DirectorNavlunRequestDetailPage.js";
import DirectorNavlunRequestPage from "./components/pages/Director/DirectorNavlunRequestPage.js";
import DirectorNavlunCompanyPage from "./components/pages/Director/DirectorNavlunCompanyPage.js";
import SevkiyatPlanlamaListe from "./components/pages/sevkiyat/SevkiyatPlanlamaList.js";
import PaymentDueListDemo from "./components/pages/foreign-trade/PaymentPage.js";
import NavlunFreightPricePage from "./components/pages/foreign-trade/NavlunPage.js";
import DiibTemporaryClosurePage from "./components/pages/Accounting/DiipPage.js";
import ScadaDashboard from "./components/pages/uretim/ScadaDashboard.js";
import KantarCapturePage from "./components/pages/SevkiyatCam/SevkiyatKantarPage.js";
import YuklemeControlListPage from "./components/pages/SevkiyatCam/YuklemeControlListPage.js";
import YuklemeControlDetailPage from "./components/pages/SevkiyatCam/YuklemeControlDetail.js";
import KalipHizAnalizi from "./components/pages/uretim/kalipAnalizPage.js";
import AylikKalipKullanimAnalizi from "./components/pages/uretim/AylikKalipKullanimPage.js";
import OperatorDurusKpiPage from "./components/pages/uretim/OperatorDurusKpiPage.js";
import InvoiceComparison from "./components/pages/Accounting/EarsivFaturaPage.js";
import DomesticPurchaseXmlPage from "./components/pages/Accounting/DomesticPurchaseXmlPage.js";
import DiibReconciliationPage from "./components/pages/Accounting/DiibReconciliationPage.js";
import MonthlyMealMenuPage from "./components/pages/MealList/MealListMonthly.jsx";
import OvertimeTrackingPage from "./components/pages/common/OvertimeTrackingPage.jsx";
import OvertimeAnalysisPage from "./components/pages/common/OvertimeAnalysisPage.jsx";
import KaizenPublicForm from "./components/pages/Kaizen/KaizenPublicForm.js";
import KaizenSuggestionList from "./components/pages/Kaizen/KaizenSuggestionList.js";
Modal.setAppElement("#root");

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Giriş ve kayıt */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/oneri" element={<KaizenPublicForm />} />
          {/* Konteyner yükleme planı müşteri linki (girişsiz, süreli token) */}
          <Route path="/yukleme-plani/:token" element={<KonteynerSunumPage publicMode />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/knowledge" element={<KnowledgeBase />} />
          <Route
            path="/HizPerformansRaporuPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="hizKontrolAnaliz_get">
                <HizPerformansRaporuPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route path="/knowledge/:id" element={<KnowledgeDetail />} />{" "}
          <Route
            path="/shareddocumentall"
            element={
              <ProtectedRouteWithPerm requiredPerm="document_shared_all">
                <SharedDocumentAll />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/SevkiyatListe"
            element={
              <ProtectedRouteWithPerm requiredPerm="sevkiyat_get_list">
                <SevkiyatListe />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/SevkiyatPlanlamaListe"
            element={
              <ProtectedRouteWithPerm requiredPerm="sevkiyat_get_list_planlama">
                <SevkiyatPlanlamaListe />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DofiWizard"
            element={
              <ProtectedRouteWithPerm requiredPerm="dof_set">
                <DofiWizard />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DofList"
            element={
              <ProtectedRouteWithPerm>
                <DofList />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/KaizenOnerileri"
            element={
              <ProtectedRouteWithPerm requiredPerm="kaizen_view">
                <KaizenSuggestionList />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DofEdit/:id"
            element={
              <ProtectedRouteWithPerm requiredPerm="dof_update">
                <DofEdit />
              </ProtectedRouteWithPerm>
            }
          />
          {/* DÖF detay: giriş yapmış herkes açabilir; backend yalnızca açan / atanan / dof_viewAll yetkililere veriyi döner (mail linki buraya gelir) */}
          <Route
            path="/DofDetay/:id"
            element={
              <ProtectedRouteWithPerm>
                <DofDetail />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ortakKalite"
            element={
              <ProtectedRouteWithPerm requiredPerm="kalite_shared_viewOwn">
                <SharedQualityDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/quality"
            element={
              <ProtectedRouteWithPerm requiredPerm="kalite_viewOwn">
                <QualityCertifica />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/UretimPlanlamaPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="hat_hiz_standart_get">
                <UretimPlanlamaPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/planning/sevkiyat-kameralari"
            element={
              <ProtectedRouteWithPerm requiredPerm="sevkiyat_live_camera_view">
                <SevkiyatLiveCameraPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/planning/uretim-satis-raporu"
            element={
              <ProtectedRouteWithPerm requiredPerm="planlama_uretim_satis_raporu">
                <ProductionSalesSummaryPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DirectorNavlunCompany"
            element={
              <ProtectedRouteWithPerm>
                <DirectorNavlunCompanyPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DirectorNavlunRequest"
            element={
              <ProtectedRouteWithPerm>
                <DirectorNavlunRequestPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DirectorNavlunRequestDetail/:id"
            element={
              <ProtectedRouteWithPerm>
                <DirectorNavlunRequestDetailPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DirectorNavlunAnalysis"
            element={
              <ProtectedRouteWithPerm>
                <DirectorNavlunAnalysisPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/CleaningPlanManagement"
            element={
              <ProtectedRouteWithPerm requiredPerm="cleaningPlan_list">
                <CleaningPlanManagement />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/equipmentPlanManagement"
            element={
              <ProtectedRouteWithPerm requiredPerm="equipment_plan_list">
                <EquipmentPlanManagement />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/HygienePlanPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="idariBakim_get">
                <HygienePlanPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DiningHallCleaningPlanManagement"
            element={
              <ProtectedRouteWithPerm requiredPerm="diningHallCleaningPlan_list">
                <DiningHallCleaningPlanManagement />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/IadeRapor"
            element={
              <ProtectedRouteWithPerm requiredPerm="kalite_viewOwn">
                <IadeRapor />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/SevkRapor"
            element={
              <ProtectedRouteWithPerm requiredPerm="sevk_rapor">
                <SevkRapor />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/standardDocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="standart_viewOwn">
                <StandardDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/uretimDocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_viewOwn">
                <UretimDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/OperatorPerformansPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_operatorscreen">
                <OperatorPerformansPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/BoruProfilAnlik"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_boruProfilAnlik">
                <BoruProfilAnlik />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/BoruProfilUretimGunlukAnaliz"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_boruProfilUretimGunlukAnaliz">
                <BoruProfilUretimGunlukAnaliz />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ScadaDashboard"
            element={
              <ProtectedRouteWithPerm requiredPerm="scadaView">
                <ScadaDashboard />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/OperatorScreen"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_operatorscreen">
                <OperatorScreen />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/boruProfilDetay/:id"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_boruProfilAnlik">
                <OperatorPageV3 />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/CustomerDetail/:id"
            element={
              <ProtectedRouteWithPerm requiredPerm="customer_get">
                <CustomerDetailPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/CustomerList"
            element={
              <ProtectedRouteWithPerm requiredPerm="customer_get">
                <CustomerListPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/aylikBoruProfilAnaliz"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_aylikBoruProfilAnaliz">
                <AylikBoruProfilAnaliz />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ToplamGunlukSureAnaliz"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_aylikBoruProfilAnaliz">
                <ToplamGunlukSureAnaliz />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/BoruSureAnaliz"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_aylikBoruProfilAnaliz">
                <BoruSureAnaliz />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/accountingDocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="muhasebe_viewOwn">
                <AccountingDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ortakMuhasebe"
            element={
              <ProtectedRouteWithPerm requiredPerm="muhasebe_shared_viewOwn">
                <SharedAccountingDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/personellistik"
            element={
              <ProtectedRouteWithPerm requiredPerm="InsanKaynaklari_personel_get">
                <IKPersonelList />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ortakInsanKaynaklari"
            element={
              <ProtectedRouteWithPerm requiredPerm="insanKaynaklari_shared_viewOwn">
                <SharedHumanResourcesDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ortakDisTicaret"
            element={
              <ProtectedRouteWithPerm requiredPerm="disTicaret_shared_viewOwn">
                <SharedForeignTradeDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/eukota"
            element={
              <ProtectedRouteWithPerm requiredPerm="disTicaret_steelone">
                <EUkota />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ukkota"
            element={
              <ProtectedRouteWithPerm requiredPerm="disTicaret_steelone">
                <UKkota />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ortakSatinAlma"
            element={
              <ProtectedRouteWithPerm requiredPerm="satinalma_shared_viewOwn">
                <SharedSatinAlmaDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ortakUretim"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_shared_viewOwn">
                <SharedUretimDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/NavlunFreightPricePage"
            element={
              <ProtectedRouteWithPerm requiredPerm="navlunFreightPrice_viewAll">
                <NavlunFreightPricePage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/MakinaUretimAnalizDemo"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_makina_analiz">
                <MakinaUretimAnalizDemo />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/MakinaOrtalamaKalinlikAnaliz"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_makina_analiz">
                <MakinaOrtalamaKalinlikAnaliz />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/MakinaExcelDebugPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_makina_analiz">
                <MakinaExcelDebugPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/MakinaExcelImportKontrolPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_makina_analiz">
                <MakinaExcelImportKontrolPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/makinaUretimAnaliz"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_makina_analiz">
                <MakinaUretimAnaliz />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/MakineSureAnaliz"
            element={
              <ProtectedRouteWithPerm requiredPerm="uretim_makine_sure_analiz">
                <MakineSureAnaliz />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/IsgDocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="isg_viewOwn">
                <IsgDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ortakIsg"
            element={
              <ProtectedRouteWithPerm requiredPerm="isg_shared_viewOwn">
                <SharedISGDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/IsgPersonelCertifica"
            element={
              <ProtectedRouteWithPerm requiredPerm="isg_personel_get">
                <IsgPersonelCertifica />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/KalipAnalizPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="scadaView">
                <KalipHizAnalizi />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/AylikKalipKullanimAnalizi"
            element={
              <ProtectedRouteWithPerm requiredPerm="scadaView">
                <AylikKalipKullanimAnalizi />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/OperatorDurusKpiPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="scadaView">
                <OperatorDurusKpiPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/salesDocuments"
            element={
              <ProtectedRouteWithPerm requiredPerm="satis_viewOwn">
                <SalesDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/planningDocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="planlama_viewOwn">
                <PlanningDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ShipmentDashboard"
            element={
              <ProtectedRouteWithPerm requiredPerm="planlama_viewOwn">
                <ShipmentDashboard />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/KonteynerPlanlama"
            element={
              <ProtectedRouteWithPerm requiredPerm="planlama_viewOwn">
                <KonteynerPlanlama />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/planning/konteyner-yukleme"
            element={
              <ProtectedRouteWithPerm requiredPerm="konteynerPlan_view">
                <KonteynerYuklemePage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/planning/konteyner-yukleme/plan/:id"
            element={
              <ProtectedRouteWithPerm requiredPerm="konteynerPlan_view">
                <KonteynerSunumPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/planning/konteyner-kurallar"
            element={
              <ProtectedRouteWithPerm requiredPerm="konteynerPlan_view">
                <KonteynerKuralPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/TicketPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="">
                <TicketPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/TicketAnalizPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="">
                <TicketAnalizPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/hathizstandart"
            element={
              <ProtectedRouteWithPerm requiredPerm="hat_hiz_standart_get">
                <HatHizStandartPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/stokAnaliz"
            element={
              <ProtectedRouteWithPerm requiredPerm="planlama_stokAnaliz">
                <StokAnaliz />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/hrDocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="InsanKaynaklari_viewOwn">
                <HumanResourcesDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/bakimdocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="bakim_viewOwn">
                <BakimDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/SatinAlmaDocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="satinalma_viewOwn">
                <SatinAlmaDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/foreignTradeDocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="disTicaret_viewOwn">
                <ForeignTradeDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/administrativeDocument"
            element={
              <ProtectedRouteWithPerm requiredPerm="IdariIsler_viewOwn">
                <AdministrativeDocument />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/vesseltable"
            element={
              <ProtectedRouteWithPerm requiredPerm="vessel_get">
                <PaymentDueList />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DiibTemporaryClosurePage"
            element={
              <ProtectedRouteWithPerm requiredPerm="vessel_get">
                <DiibTemporaryClosurePage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/PaymentDueListDemo"
            element={
              <ProtectedRouteWithPerm requiredPerm="vessel_get">
                <PaymentDueListDemo />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/ExportOrder"
            element={
              <ProtectedRouteWithPerm requiredPerm="customer_analysis">
                <ExportOrderCreatePage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/CustomerAnalysisPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="customer_analysis">
                <CustomerAnalysisPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/MailSettingsPage"
            element={
              <ProtectedRouteWithPerm requiredPerm="emailSettings">
                <MailSettingsPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/roleManagement"
            element={
              <ProtectedRouteWithPerm requiredPerm="role_get">
                <RoleManagemenetPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/admin/personel-yonetimi"
            element={
              <ProtectedRouteWithPerm requiredPerm="personel_view">
                <PersonelYonetimiPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route path="/ReminderDocument" element={<ReminderDocument />} />
          {/* Korunan sayfalar */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mesai-takip"
            element={
              <ProtectedRouteWithPerm requiredPerm="overtime_viewOwn">
                <OvertimeTrackingPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/mesai-analiz"
            element={
              <ProtectedRouteWithPerm requiredPerm="overtime_analysis">
                <OvertimeAnalysisPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/RuloStokSatisGiris"
            element={
              <ProtectedRoute requiredPerm="CustomerStokMail">
                <RuloStokSatisGiris />
              </ProtectedRoute>
            }
          />
          <Route
            path="/QualityDocumentDetailPage/:id"
            element={
              <ProtectedRoute>
                <QualityDocumentDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/QualityFileManagerPage"
            element={
              <ProtectedRoute>
                <QualityFileManagerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sevkiyat/kantar-fotograf"
            element={
              <ProtectedRoute>
                <KantarCapturePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sevkiyat/yukleme-kontrol"
            element={
              <ProtectedRoute>
                <YuklemeControlListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MonthlyMealMenuPage"
            element={
              <ProtectedRoute requiredPerm="monthlyMealMenu_view">
                <MonthlyMealMenuPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sevkiyat/yukleme-kontrol/:id"
            element={
              <ProtectedRoute>
                <YuklemeControlDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/InvoiceComparison"
            element={
              <ProtectedRoute>
                <InvoiceComparison />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DomesticPurchaseXml"
            element={
              <ProtectedRouteWithPerm requiredPerm="muhasebe_shared_viewOwn">
                <DomesticPurchaseXmlPage />
              </ProtectedRouteWithPerm>
            }
          />
          <Route
            path="/DiibReconciliation"
            element={
              <ProtectedRouteWithPerm requiredPerm="muhasebe_shared_viewOwn">
                <DiibReconciliationPage />
              </ProtectedRouteWithPerm>
            }
          />
          {/* Not Found */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
